// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__Km+Dt","width-auto":"modal_width-auto__h2H52","open":"modal_open__2qeAo","modal__exit":"modal_modal__exit__GkjWN","backdrop":"modal_backdrop__LAqOv"};